'use strict';

var Common = require('../../../packages/common');

module.exports = Common;
